<template>
  <section id="services" class="services">
    <div class="shell">
      <header v-reveal class="section-head">
        <h2>What I can build for you</h2>
        <p>
          From the back end to the apps your customers use. Start with whatever
          is slowing you down: a job someone does by hand every day, two systems
          that don’t talk, or an app you need built.
        </p>
      </header>
      <ul class="service-grid">
        <li
          v-for="(item, i) in items"
          :key="item.title"
          v-reveal
          class="service-card"
          :style="{ transitionDelay: `${(i % 3) * 80}ms` }"
        >
          <div class="service-photo">
            <img
              :src="item.image"
              :srcset="srcsetFor(item.image)"
              sizes="(max-width: 760px) calc(100vw - 40px), (max-width: 1024px) calc(50vw - 36px), 384px"
              alt=""
              width="1200"
              height="800"
              loading="lazy"
              decoding="async"
              @error="$event.target.hidden = true"
            />
          </div>
          <div class="service-body">
            <h3>{{ item.title }}</h3>
            <p>{{ item.description }}</p>
            <ul class="tag-list" aria-label="Typical tools">
              <li v-for="tag in item.tags" :key="tag">{{ tag }}</li>
            </ul>
            <a :href="item.href" class="service-link">{{ item.link }}</a>
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>
<script>
const mail = (subject) =>
  `mailto:info@westdevsolutions.com?subject=${encodeURIComponent(subject)}`;

export default {
  name: "ServicesSection",
  methods: {
    // Each service illustration ships as name.webp (1200w) and name-800.webp (800w)
    srcsetFor: (src) => `${src.replace(".webp", "-800.webp")} 800w, ${src} 1200w`,
  },
  data: () => ({
    items: [
      {
        title: "Workflow automation",
        image: "/services/automation.webp",
        description:
          "Scheduled jobs and workflows that move data between your systems and handle the repetitive work, on time, every time.",
        tags: ["Azure Functions", ".NET", "Node.js", "Email and SMS"],
        link: "Ask about automation",
        href: mail("Automation project"),
      },
      {
        title: "APIs and integrations",
        image: "/services/integrations.webp",
        description:
          "Connect your software to payment processors, shipping carriers, CRMs and each other, securely and with proper error handling.",
        tags: ["REST", "SOAP", "SFTP", "Webhooks"],
        link: "Ask about an integration",
        href: mail("Integration project"),
      },
      {
        title: "Backend systems",
        image: "/services/backend.webp",
        description:
          "The APIs, databases and business logic behind your apps, built to stay fast and reliable as your business grows.",
        tags: ["C#", ".NET", "SQL Server", "MySQL"],
        link: "Ask about a backend",
        href: mail("Backend project"),
      },
      {
        title: "Web applications",
        image: "/services/webapps.webp",
        description:
          "Full-stack web apps built end to end: customer portals, dashboards, booking systems and internal tools your team will actually use.",
        tags: ["Vue.js", "React", "Node.js", "Laravel"],
        link: "Ask about a web app",
        href: mail("Web application project"),
      },
      {
        title: "Mobile apps",
        image: "/services/mobile.webp",
        description:
          "iOS and Android apps connected to your systems, so customers and staff can book, track and pay from their phones.",
        tags: ["Flutter", "iOS", "Android", "APIs"],
        link: "Ask about a mobile app",
        href: mail("Mobile app project"),
      },
      {
        title: "Cloud and data",
        image: "/services/cloud.webp",
        description:
          "Move off ageing servers, run reliably on Azure or AWS, and turn spreadsheets and exports into clean data you can report on.",
        tags: ["Azure", "AWS", "ETL", "CI/CD"],
        link: "Ask about cloud and data",
        href: mail("Cloud and data project"),
      },
    ],
  }),
};
</script>
